import type {
	CustomItem,
	DropCountdownNoButtonType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropCountdownNoButton = (
	item: Item | CustomItem
): item is DropCountdownNoButtonType => {
	return !!(item && item.__typename === 'Drop_Countdown_No_Button');
};
